import React from 'react';

import {Colors, Text} from '@optimaxdev/design-system';
import {Icon, Attention} from '@optimaxdev/icons';

import s from './attentionMessage.scss';

/**
 * Status block for contacts item on TYP
 */
export const AttentionMessage = () => {
    return (
        <Text
            as="p"
            className={s.titlePrescription}
            color={Colors.orangeRoughy}
            lineHeight="18px"
            size="14px"
            medium
        >
            <Icon icon={Attention} strokeWidth={2} width="14px" />
            Prescription needed
        </Text>
    );
};
